import React, { memo, useState } from 'react';

import Select from '@components/common/Select';
import SubmissionButtons from '@components/common/SubmissionButtons';

import { TSelectOption } from '@interfaces/components/componentTypes';
import { IUpdateOrganisationSettingsDTO } from '@interfaces/organisation/dto/organisationsDTO';
import { IOrganisationSettingsVendors } from '@interfaces/organisation/organisations';

import { IDataForEditInterface } from '../constants';

import { getMaxKpiSelectionOptions } from './utils';

import styles from './EditSettingsForm.module.scss';

interface IEditSettingsForm {
	dataForEdit: IDataForEditInterface;
	organizationSettingsVendors: IOrganisationSettingsVendors[];
	handleUpdateOrganisationSettings: ({ vendorsSettings }: IUpdateOrganisationSettingsDTO) => void;
	organisationId?: string;
	closeEditModal: () => void;
	onClose: () => void;
}

const EditSettingsForm = ({
	dataForEdit,
	organizationSettingsVendors,
	handleUpdateOrganisationSettings,
	organisationId,
	closeEditModal,
	onClose,
}: IEditSettingsForm) => {
	const [maxKpiSelected, setMaxKpiSelected] = useState<TSelectOption | null>(null);

	const onSelectChange = (selectedOption: TSelectOption) => setMaxKpiSelected(selectedOption);

	const availableKpiNumber = organizationSettingsVendors
		.find(item => item.vendor.name === dataForEdit.vendor.name)?.availableKpi;

	const maxKpiSelectionOptions = getMaxKpiSelectionOptions(availableKpiNumber || 0);

	const onSave = () => {
		if (!organisationId) return;

		handleUpdateOrganisationSettings({
			vendorsSettings: [{
				vendor: dataForEdit.vendor.name,
				maxKpiSelectionInCharts: maxKpiSelected?.value as number,
				status: dataForEdit.status,
			}],
			organisationId,
		});

		closeEditModal();
	};

	return (
		<>
			<div className={styles.formContainer}>
				<div className={styles.vendorText}>
					Vendor: {dataForEdit.vendor.title}
				</div>
				<Select
					handleChange={onSelectChange}
					isClearable
					isWithoutUseForms
					label='Max KPI Selection In Charts'
					name='maxKpiSelection'
					options={maxKpiSelectionOptions}
					placeholder='Select number'
					value={maxKpiSelected}
					width='200px'
				/>
			</div>
			<SubmissionButtons
				className={styles.submissionButtons}
				negativeHandler={onClose}
				positiveHandler={onSave}
				positiveLabel='Save'
			/>
		</>
	);
};

export default memo(EditSettingsForm);
